import { render, staticRenderFns } from "./InformationsPage.vue?vue&type=template&id=160ca292&scoped=true&"
import script from "./InformationsPage.vue?vue&type=script&lang=js&"
export * from "./InformationsPage.vue?vue&type=script&lang=js&"
import style0 from "./InformationsPage.vue?vue&type=style&index=0&id=160ca292&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "160ca292",
  null
  
)

export default component.exports